import { ConfigFlags } from 'store/app/types';

export const DEFAULT_CONFIG_FLAGS: ConfigFlags = {
  isSmartLockActive: false,
  mobileMapping: {
    sendOtpCaptcha: false,
    verifyOtpCaptcha: false,
  },
  customerAlsoBought: {
    algo: 'coccurence_direct',
    status: '0',
    message: '',
  },
  customerAlsoViewed: {
    algo: 'coccurence_simple',
    status: '0',
    message: '',
  },
  auth: {
    checkExistenceCaptcha: false,
    sendOtpCaptcha: false,
    loginCaptcha: false,
    signupCaptcha: false,
  },
};
